<template>
  <div class="right-chart-2 card-background p-2">
    <ComponentSubtitle>
      <span class="sub-title" @click="visible = true">人群管理情况概述</span>
    </ComponentSubtitle>

    <div class="rc1-chart-container">
      <div class="chart-container border" style="height: 65%">
        <div class="chart-title" style="top: 10px">近一年人群分布图</div>
        <div id="evaluate" style="height: calc(100%); width: 460px"></div>
      </div>
      <div class="chart-container pt-2" style="">
        <!-- <div class="chart-title">人群变化趋势分布图</div> -->
        <!-- <div id="reduce" style="height: 140px; width: 460px"></div> -->
        <RiskPie></RiskPie>
      </div>
    </div>
    <ComponentDialogIllness :show.sync="visible"></ComponentDialogIllness>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { mapGetters } from "vuex";
import ComponentSubtitle from "./ComponentSubtitle.vue";
import ComponentDialogIllness from "./DialogIllness.vue";
import RiskPie from "./RiskPie.vue";

export default {
  name: "RightChart2",

  data() {
    return {
      visible: false,
    };
  },
  computed: {
    ...mapGetters(["globalData"]),
  },
  watch: {
    globalData: {
      handler(n, o) {
        this.$nextTick(() => {
          this.initChartDemo(n);
          // this.initReduceChart();
        });
      },
    },
  },
  components: {
    ComponentSubtitle,
    RiskPie,
    ComponentDialogIllness,
  },
  methods: {
    initChart() {
      const backgroundColor = "";
      const color = ["#34C724", "#FF8800", "#F54A45"]; //2个以上的series就需要用到color数组
      const title = {
        show: true,
        text: "",
        textStyle: {
          color: "#fff",
          fontSize: 16,
        },
        padding: 0,
        top: 35,
        left: 40,
      };
      const legend = {
        show: true,
        //data，就是取得每个series里面的name属性。
        orient: "horizontal",
        icon: "circle", //图例形状
        padding: 0,
        top: 35,
        right: 40,
        itemWidth: 14, //小圆点宽度
        itemHeight: 14, // 小圆点高度
        itemGap: 21, // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
        textStyle: {
          fontSize: 10,
          color: this.$color.textColor,
          // color: "#00E4FF",
        },
      };
      const tooltip = {
        show: true,
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      };
      const originData = [
        {
          name: "基本健康人群",
          data: this.globalData.riskChart.seriesData.find(
            (v) => v.name == "基本健康人群"
          ).data,
        },
        {
          name: "专项关爱人群",
          data: this.globalData.riskChart.seriesData.find(
            (v) => v.name == "专项关爱人群"
          ).data,
        },
        {
          name: "重点关爱人群",
          data: this.globalData.riskChart.seriesData.find(
            (v) => v.name == "重点关爱人群"
          ).data,
        },
      ];
      const commonSeriesFn = (index) => ({
        type: "bar",
        barWidth: "30%", //柱条的宽度，不设时自适应。
        stack: "total",
        emphasis: {
          focus: "series",
        },
        itemStyle: {},
        showBackground: false, //柱子是否带有背景，默认是没有的
        backgroundStyle: {
          //只有showBackground=true，设置backgroundStyle才会有效果
          color: "rgba(180, 180, 180, .2)", //
        },
      });
      const series = originData.map((item, index) => ({
        ...item,
        ...commonSeriesFn(index),
      }));
      let option = {
        backgroundColor,
        color,
        title,
        legend,
        tooltip,
        grid: {
          top: "0%",
          left: "3%",
          right: "4%",
          bottom: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: true, //显示Y轴
          },
          axisTick: {
            show: false, //不显示小的刻度线
          },
          axisLabel: {
            color: this.$color.borderColor,
            textStyle: {
              fontSize: 13,
            },
          },
          splitLine: {
            show: false, //不显示竖向分割线
          },
          data: this.globalData.riskChart.data,
        },
        yAxis: {
          type: "value",
          // type: "value",

          axisLine: {
            show: true, //显示X轴
          },
          axisTick: {
            show: false, //不显示小的刻度线
          },
          splitLine: {
            show: false, //不显示横向分割线
          },
          axisLabel: {
            color: this.$color.borderColor,
            textStyle: {
              fontSize: 13,
            },
          },
        },
        series,
      };
      //图表自动轮播高亮显示函数 myChart直接用
      const animation = (delay = 3000) => {
        let currentIndex = -1;
        const length = option.series[0].data.length;
        setInterval(() => {
          currentIndex = (currentIndex + 1) % length;
          // 高亮当前图形
          myChart.dispatchAction({
            type: "highlight",
            seriesIndex: 0,

            dataIndex: currentIndex,
          });
          // 显示 tooltip
          myChart.dispatchAction({
            type: "showTip",

            seriesIndex: 0,
            dataIndex: currentIndex,
          });
        }, delay);
      };
      // animation(10000);

      var myChart = echarts.init(document.getElementById("evaluate"));
      myChart.setOption(option);
    },
    initChartDemo(globalData) {
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          // left: "2%",
          // right: "4%",
          // bottom: "14%",
          // top: "16%",
          top: "20%",
          left: "3%",
          right: "4%",
          bottom: "5%",
          containLabel: true,
        },
        legend: {
          right: 100,
          top: 28,
          textStyle: {
            fontSize: 10,
            color: this.$color.textColor,
          },
          itemWidth: 12,
          itemHeight: 10,
        },
        xAxis: {
          type: "category",
          data: globalData && globalData.riskChart && globalData.riskChart.data,
          axisLabel: {
            color: this.$color.borderColor,
            textStyle: {
              fontSize: 13,
            },
          },
          splitLine: {
            show: false, //不显示竖向分割线
          },
        },

        yAxis: {
          type: "value",
          axisLine: {
            show: false,
            // lineStyle: {
            //   color: "#333",
            // },
          },
          splitLine: {
            show: true, //不显示grid水平分割线
            type: "dashed",
            lineStyle: {
              // color: "#e2e9ff",
              color: "rgba(255,255,255,0.15)",
            },
          },
          axisLabel: {
            color: this.$color.borderColor,
            textStyle: {
              fontSize: 13,
            },
          },
        },

        series: [
          {
            name: "基本健康人群",
            type: "bar",
            itemStyle: {
              normal: {
                // 颜色上下渐变
                color: "#34C724",
                barBorderRadius: [10, 10, 0, 0],
              },
            },
            data:
              globalData &&
              globalData.riskChart &&
              globalData.riskChart.seriesData &&
              globalData &&
              globalData.riskChart &&
              globalData.riskChart.seriesData.find(
                (v) => v.name == "基本健康人群"
              ).data,
          },
          {
            name: "专项关爱人群",
            type: "bar",
            itemStyle: {
              normal: {
                // 颜色上下渐变
                color: "#FF8800",
                barBorderRadius: [10, 10, 0, 0],
              },
            },
            data:
              globalData &&
              globalData.riskChart &&
              globalData.riskChart.seriesData &&
              globalData &&
              globalData.riskChart &&
              globalData.riskChart.seriesData.find(
                (v) => v.name == "专项关爱人群"
              ).data,
          },
          {
            name: "重点关爱人群",
            type: "bar",
            itemStyle: {
              normal: {
                // 颜色上下渐变
                color: "#F54A45",
                barBorderRadius: [10, 10, 0, 0],
              },
            },
            data:
              globalData &&
              globalData.riskChart &&
              globalData.riskChart.seriesData &&
              globalData &&
              globalData.riskChart &&
              globalData.riskChart.seriesData.find(
                (v) => v.name == "重点关爱人群"
              ).data,
          },
        ],
      };
      var myChart = echarts.init(document.getElementById("evaluate"));
      myChart.setOption(option);
    },

    initReduceChart() {
      const backgroundColor = "rgba(243, 243, 243, 0.7)";
      const color = ["#34C724", "#FF8800", "#F54A45"]; //2个以上的series就需要用到color数组
      const title = {
        text: "",
        textStyle: {
          color: "#fff",
          fontSize: 16,
        },
        padding: 0,
        top: 35,
        left: 25,
      };
      const legend = {
        //data，就是取得每个series里面的name属性。
        // orient: "horizontal",
        // icon: "circle", //图例形状
        // padding: 0,
        top: 18,
        right: 40,
        // itemWidth: 11, //小圆点宽度
        // itemHeight: 11, // 小圆点高度
        // itemGap: 21, // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
        textStyle: {
          fontSize: 10,
          color: this.$color.textColor,
        },
      };
      const tooltip = {
        show: true,
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: function (val) {
          var tipText = "";
          tipText +=
            val[0].name +
            " : " +
            "<br/>" +
            val[0].marker +
            val[0].seriesName +
            " : " +
            val[0].value +
            "%<br/>" +
            val[1].marker +
            val[1].seriesName +
            " : " +
            val[1].value +
            "%<br/>" +
            val[2].marker +
            val[2].seriesName +
            " : " +
            val[2].value +
            "%<br/>";
          return tipText;
        },
      };
      let seriesData = [
        {
          name: "基本健康人群",
          data: this.globalData.riskProportionData.seriesData.find(
            (v) => v.name == "基本健康人群"
          ).data,
        },
        {
          name: "专项关爱人群",
          data: this.globalData.riskProportionData.seriesData.find(
            (v) => v.name == "专项关爱人群"
          ).data,
        },
        {
          name: "重点关爱人群",
          data: this.globalData.riskProportionData.seriesData.find(
            (v) => v.name == "重点关爱人群"
          ).data,
        },
      ];
      const commonConfigFn = (index) => {
        return {
          type: "line",
          smooth: false,
          symbol: "emptyCircle", //空心小圆点。线条小圆点形状
          symbolSize: 6, //小圆点大小
          itemStyle: {
            //还是小圆点设置
          },

          label: {
            show: false, //不显示小圆点上的label文字
          },
          lineStyle: {
            width: 1, //线条设置
          },

          areaStyle: {
            //填充线条下面的面积区域颜色。（areaStyle只是锦上添花）
            opacity: 0.2,
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: color[index], // 上处的颜色
                },
                {
                  offset: 1,
                  color: "transparent", // 下处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
        };
      };

      seriesData = seriesData.map((item, index) => ({
        ...item,
        ...commonConfigFn(index),
      }));
      let option = {
        backgroundColor,
        color,
        title,
        tooltip,
        legend,
        grid: {
          top: "20%",
          left: "3%",
          right: "4%",
          bottom: "5%",
          containLabel: true,
        },

        xAxis: {
          show: true, //显示x轴+x轴label文字
          type: "category",
          boundaryGap: false, //从Y轴出发，这个false很好的
          axisLine: {
            show: true, //显示x坐标轴轴线
            lineStyle: {
              color: "rgba(255,255,255,.4)",
            },
          },
          axisTick: {
            show: false, //不显示x坐标1cm刻度
          },
          axisLabel: {
            // color: "#e2e9ff",
            color: this.$color.borderColor,
            textStyle: {
              fontSize: 13,
            },
          },
          splitLine: {
            show: false, //不显示grid竖向分割线
          },

          data: this.globalData.riskProportionData.data,
        },
        yAxis: {
          type: "value",
          max: 100, //最大值
          min: 0, //最小值
          interval: 20, //间隔
          axisLine: {
            show: false,
            lineStyle: {
              color: "#e2e9ff",
            },
          },
          axisLabel: {
            color: this.$color.borderColor,
            textStyle: {
              fontSize: 13,
            },
            formatter: function (val) {
              //百分比显示
              return val + "%";
            },
          },
          splitLine: {
            show: true, //不显示grid水平分割线
            type: "dashed",
            lineStyle: {
              // color: "#e2e9ff",
              color: "rgba(255,255,255,0.15)",
            },
          },
        },

        series: seriesData,
      };

      var myChart = echarts.init(document.getElementById("reduce"));
      myChart.setOption(option);
    },
  },
  mounted() {
    // this.initChart();
  },
};
</script>

<style lang="less">
.right-chart-2 {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  // background: #fff;
  .rc1-header {
    font-size: 24px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
  }

  .rc1-chart-container {
    flex: 1;
    // flex-direction: column;
    overflow: hidden;
    .chart-container {
      position: relative;
      .chart-title {
        position: absolute;
        font-size: 12px;
        font-weight: bold;
        z-index: 100000;
        top: 0px;
        left: 50%;
        transform: translateX(-50%);

        // color: #fff;
      }
    }
  }

  .left {
    width: 30%;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .number {
      font-size: 34px;
      color: #096dd9;
      font-weight: bold;
      margin-bottom: 30px;
    }
  }

  .right {
    height: 100%;
    padding-bottom: 20px;
    padding-right: 20px;
    box-sizing: border-box;
  }
}
</style>
